import ProductCategoryPaths from 'modules/ProductCategory/paths';
import PromotionCategoryPaths from 'modules/PromotionCategory/paths';
import ShippingMethodPaths from 'modules/ShippingMethod/paths';
import PaymentMethodPaths from 'modules/PaymentMethod/paths';
import UserPaths from 'modules/User/paths';
import TimetablePaths from 'modules/Timetable/paths';
import BannerPlacePaths from 'modules/BannerPlace/paths';
import BannerPaths from 'modules/Banner/paths';
import ProductListAdPaths from 'modules/ProductListAd/paths';
import AdminUserPaths from 'modules/AdminUser/paths';
import ProductPaths from 'modules/Product/paths';
import CmsPaths from 'modules/Cms/paths';
import ProductAttributePaths from 'modules/ProductAttribute/paths';
import UrlAliasPaths from 'modules/UrlAlias/paths';
import OrderPaths from 'modules/Order/paths';
import CouponPaths from 'modules/Coupon/paths';
import DonationPaths from 'modules/Donation/paths';

enum Path {
    root = '/',
    login = '/login',
    dashboard = '/dashboard',
    resetPassword = '/reset-password',
    activateEmail = '/activate',

    shipping = '/shipping',
    users = '/users',
    banners = '/banners',
    products = '/products',
}

const Paths = {
    ...ProductCategoryPaths,
    ...PromotionCategoryPaths,
    ...ShippingMethodPaths,
    ...PaymentMethodPaths,
    ...UserPaths,
    ...AdminUserPaths,
    ...TimetablePaths,
    ...BannerPlacePaths,
    ...BannerPaths,
    ...ProductListAdPaths,
    ...ProductPaths,
    ...DonationPaths,
    ...CmsPaths,
    ...UrlAliasPaths,
    ...ProductAttributePaths,
    ...OrderPaths,
    ...CouponPaths,
    ...Path,
};

export default Paths;



// WEBPACK FOOTER //
// ./src/utils/Path.ts